import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: {
    kpi: {
      switchOnline: 19,
      switchTotal: 20,
      apOnline: 38,
      apTotal: 42,
      clientsOnlineLast: 241,
      clientsNew: 3,
      wirelessTotalTrafficBytes: 183886079385.6, // 171.26 GB
      poeBudgetPercent: 94.91,
      poeCapacityW: 12603,
      mostApChannel: {
        band: "2.4GHz",
        channel: 1,
        count: 18
      }
    },
    charts: {
      switchStatus: {
        totalUniqueDevices: 20,
        daily: [
          { online: 19, offline: 1 },
          { online: 20, offline: 0 },
          { online: 19, offline: 1 },
          { online: 18, offline: 2 },
          { online: 19, offline: 1 },
          { online: 20, offline: 0 },
          { online: 19, offline: 1 }
        ]
      },
      apStatus: {
        totalUniqueDevices: 42,
        daily: [
          { online: 38, offline: 4 },
          { online: 40, offline: 2 },
          { online: 39, offline: 3 },
          { online: 41, offline: 1 },
          { online: 38, offline: 4 },
          { online: 42, offline: 0 },
          { online: 39, offline: 3 }
        ]
      },
      clientStatus: [
        { online: 241, new: 3 },
        { online: 250, new: 5 },
        { online: 235, new: 4 },
        { online: 245, new: 8 },
        { online: 240, new: 2 },
        { online: 255, new: 6 },
        { online: 248, new: 3 }
      ],
      ssidTraffic: [
        {
          ssid: "AAA",
          daily: [
            { total: 8532342430.5, uplink: 5042340000.0, downlink: 3490002430.5 },
            { total: 7532342430.5, uplink: 4542340000.0, downlink: 2990002430.5 },
            { total: 9532342430.5, uplink: 5542340000.0, downlink: 3990002430.5 },
            { total: 8032342430.5, uplink: 4842340000.0, downlink: 3190002430.5 },
            { total: 8232342430.5, uplink: 4942340000.0, downlink: 3290002430.5 },
            { total: 8832342430.5, uplink: 5242340000.0, downlink: 3590002430.5 },
            { total: 9032342430.5, uplink: 5342340000.0, downlink: 3690002430.5 }
          ]
        },
        {
          ssid: "BBB",
          daily: [
            { total: 6532342430.5, uplink: 3042340000.0, downlink: 3490002430.5 },
            { total: 5532342430.5, uplink: 2542340000.0, downlink: 2990002430.5 },
            { total: 7532342430.5, uplink: 3542340000.0, downlink: 3990002430.5 },
            { total: 6032342430.5, uplink: 2842340000.0, downlink: 3190002430.5 },
            { total: 6232342430.5, uplink: 2942340000.0, downlink: 3290002430.5 },
            { total: 6832342430.5, uplink: 3242340000.0, downlink: 3590002430.5 },
            { total: 7032342430.5, uplink: 3342340000.0, downlink: 3690002430.5 }
          ]
        },
        {
          ssid: "CCC",
          daily: [
            { total: 4532342430.5, uplink: 2042340000.0, downlink: 2490002430.5 },
            { total: 3532342430.5, uplink: 1542340000.0, downlink: 1990002430.5 },
            { total: 5532342430.5, uplink: 2542340000.0, downlink: 2990002430.5 },
            { total: 4032342430.5, uplink: 1842340000.0, downlink: 2190002430.5 },
            { total: 4232342430.5, uplink: 1942340000.0, downlink: 2290002430.5 },
            { total: 4832342430.5, uplink: 2242340000.0, downlink: 2590002430.5 },
            { total: 5032342430.5, uplink: 2342340000.0, downlink: 2690002430.5 }
          ]
        },
        {
          ssid: "DDD",
          daily: [
            { total: 3532342430.5, uplink: 1542340000.0, downlink: 1990002430.5 },
            { total: 2532342430.5, uplink: 1042340000.0, downlink: 1490002430.5 },
            { total: 4532342430.5, uplink: 2042340000.0, downlink: 2490002430.5 },
            { total: 3032342430.5, uplink: 1242340000.0, downlink: 1790002430.5 },
            { total: 3232342430.5, uplink: 1342340000.0, downlink: 1890002430.5 },
            { total: 3832342430.5, uplink: 1642340000.0, downlink: 2190002430.5 },
            { total: 4032342430.5, uplink: 1742340000.0, downlink: 2290002430.5 }
          ]
        },
        {
          ssid: "EEE",
          daily: [
            { total: 2532342430.5, uplink: 1042340000.0, downlink: 1490002430.5 },
            { total: 1532342430.5, uplink: 542340000.0, downlink: 990002430.5 },
            { total: 3532342430.5, uplink: 1542340000.0, downlink: 1990002430.5 },
            { total: 2032342430.5, uplink: 842340000.0, downlink: 1190002430.5 },
            { total: 2232342430.5, uplink: 942340000.0, downlink: 1290002430.5 },
            { total: 2832342430.5, uplink: 1242340000.0, downlink: 1590002430.5 },
            { total: 3032342430.5, uplink: 1342340000.0, downlink: 1690002430.5 }
          ]
        },
        {
          ssid: "FFF",
          daily: [
            { total: 1532342430.5, uplink: 542340000.0, downlink: 990002430.5 },
            { total: 1232342430.5, uplink: 442340000.0, downlink: 790002430.5 },
            { total: 1832342430.5, uplink: 642340000.0, downlink: 1190002430.5 },
            { total: 1432342430.5, uplink: 504234000.0, downlink: 928108430.5 },
            { total: 1332342430.5, uplink: 474234000.0, downlink: 858108430.5 },
            { total: 1632342430.5, uplink: 574234000.0, downlink: 1058108430.5 },
            { total: 1703234243.05, uplink: 604234000.0, downlink: 1099000243.05 }
          ]
        },
        {
          ssid: "GGG",
          daily: [
            { total: 1232342430.5, uplink: 442340000.0, downlink: 790002430.5 },
            { total: 932342430.5, uplink: 342340000.0, downlink: 590002430.5 },
            { total: 1432342430.5, uplink: 542340000.0, downlink: 890002430.5 },
            { total: 1132342430.5, uplink: 384234000.0, downlink: 748108430.5 },
            { total: 1032342430.5, uplink: 354234000.0, downlink: 678108430.5 },
            { total: 1332342430.5, uplink: 454234000.0, downlink: 878108430.5 },
            { total: 1403234243.05, uplink: 484234000.0, downlink: 919000243.05 }
          ]
        },
        {
          ssid: "HHH",
          daily: [
            { total: 932342430.5, uplink: 342340000.0, downlink: 590002430.5 },
            { total: 632342430.5, uplink: 242340000.0, downlink: 390002430.5 },
            { total: 1132342430.5, uplink: 442340000.0, downlink: 690002430.5 },
            { total: 832342430.5, uplink: 284234000.0, downlink: 548108430.5 },
            { total: 732342430.5, uplink: 254234000.0, downlink: 478108430.5 },
            { total: 1032342430.5, uplink: 354234000.0, downlink: 678108430.5 },
            { total: 1103234243.05, uplink: 384234000.0, downlink: 719000243.05 }
          ]
        },
        {
          ssid: "III",
          daily: [
            { total: 832342430.5, uplink: 284234000.0, downlink: 548108430.5 },
            { total: 532342430.5, uplink: 184234000.0, downlink: 348108430.5 },
            { total: 1032342430.5, uplink: 354234000.0, downlink: 678108430.5 },
            { total: 732342430.5, uplink: 244234000.0, downlink: 488108430.5 },
            { total: 632342430.5, uplink: 214234000.0, downlink: 418108430.5 },
            { total: 932342430.5, uplink: 314234000.0, downlink: 618108430.5 },
            { total: 1003234243.05, uplink: 344234000.0, downlink: 659000243.05 }
          ]
        },
        {
          ssid: "JJJ",
          daily: [
            { total: 732342430.5, uplink: 244234000.0, downlink: 488108430.5 },
            { total: 432342430.5, uplink: 144234000.0, downlink: 288108430.5 },
            { total: 932342430.5, uplink: 314234000.0, downlink: 618108430.5 },
            { total: 632342430.5, uplink: 204234000.0, downlink: 428108430.5 },
            { total: 532342430.5, uplink: 174234000.0, downlink: 358108430.5 },
            { total: 832342430.5, uplink: 274234000.0, downlink: 558108430.5 },
            { total: 903234243.05, uplink: 304234000.0, downlink: 599000243.05 }
          ]
        },
        {
          ssid: "KKK",
          daily: [
            { total: 632342430.5, uplink: 204234000.0, downlink: 428108430.5 },
            { total: 332342430.5, uplink: 104234000.0, downlink: 228108430.5 },
            { total: 832342430.5, uplink: 274234000.0, downlink: 558108430.5 },
            { total: 532342430.5, uplink: 164234000.0, downlink: 368108430.5 },
            { total: 432342430.5, uplink: 134234000.0, downlink: 298108430.5 },
            { total: 732342430.5, uplink: 234234000.0, downlink: 498108430.5 },
            { total: 803234243.05, uplink: 254234000.0, downlink: 549000243.05 }
          ]
        }
      ],
      wirelessTrafficUsage: [
        { uplink: 4343498000.0, downlink: 1032325000.0 },
        { uplink: 3500000000.0, downlink: 800000000.0 },
        { uplink: 4800000000.0, downlink: 1200000000.0 },
        { uplink: 4200000000.0, downlink: 1100000000.0 },
        { uplink: 4500000000.0, downlink: 1150000000.0 },
        { uplink: 4700000000.0, downlink: 1180000000.0 },
        { uplink: 4900000000.0, downlink: 1220000000.0 }
      ],
      wirelessClientRssi: [
        { weak: 25, fair: 75, good: 185 },
        { weak: 22, fair: 78, good: 190 },
        { weak: 28, fair: 70, good: 177 },
        { weak: 24, fair: 76, good: 180 },
        { weak: 26, fair: 74, good: 185 },
        { weak: 20, fair: 80, good: 195 },
        { weak: 18, fair: 82, good: 200 }
      ],
      poePowerConsumption: {
        budgetUsagePercent: [70.5, 75.0, 72.8, 82.5, 78.5, 85.0, 80.0]
      }
    },
    rankings: {
      topSwitchesByTraffic: [
        { name: "SW-10", value: 679.12, rankBadge: "▲2", previousValue: 659.12 },
        { name: "SW-02", value: 553.23, rankBadge: "▼1", previousValue: 583.23 },
        { name: "SW-05", value: 423.24, rankBadge: "▲4", previousValue: 383.24 },
        { name: "SW-01", value: 283.08, rankBadge: "NEW", previousValue: null },
        { name: "SW-07", value: 183.08, rankBadge: "▲3", previousValue: 153.08 }
      ],
      topSwitchPortsByTraffic: [
        { name: "SWP-05", value: 1400.0, rankBadge: "▲4", previousValue: 1000.0 },
        { name: "SWP-03", value: 1150.0, rankBadge: "▼2", previousValue: 1350.0 },
        { name: "SWP-11", value: 900.0, rankBadge: "NEW", previousValue: null },
        { name: "SWP-22", value: 600.0, rankBadge: "=", previousValue: 600.0 },
        { name: "SWP-18", value: 350.0, rankBadge: "▼7", previousValue: 420.0 }
      ],
      topAccessPointsByTraffic: [
        { name: "AP-05", value: 690.0, rankBadge: "▲2", previousValue: 670.0 },
        { name: "AP-02", value: 610.0, rankBadge: "▼1", previousValue: 620.0 },
        { name: "AP-03", value: 450.0, rankBadge: "▲4", previousValue: 410.0 },
        { name: "AP-04", value: 310.0, rankBadge: "▲3", previousValue: 280.0 },
        { name: "AP-01", value: 160.0, rankBadge: "NEW", previousValue: null }
      ],
      topPoePowerConsumption: [
        { name: "SW-04", value: 135.0, rankBadge: "=", previousValue: 135.0 },
        { name: "SW-05", value: 115.0, rankBadge: "▲1", previousValue: 105.0 },
        { name: "SW-02", value: 95.0, rankBadge: "▲4", previousValue: 91.0 },
        { name: "SW-01", value: 65.0, rankBadge: "NEW", previousValue: null },
        { name: "SW-08", value: 45.0, rankBadge: "▲3", previousValue: 42.0 }
      ],
      topCpuByUsage: [
        { name: "SW-01", value: 85.0, rankBadge: "=", previousValue: 85.0 },
        { name: "SW-02", value: 78.0, rankBadge: "=", previousValue: 78.0 },
        { name: "SW-10", value: 65.0, rankBadge: "▲2", previousValue: 63.0 },
        { name: "SW-08", value: 58.0, rankBadge: "▼1", previousValue: 59.0 },
        { name: "SW-03", value: 48.0, rankBadge: "▲7", previousValue: 41.0 }
      ],
      topMemoryByUsage: [
        { name: "SW-02", value: 92.0, rankBadge: "▲1", previousValue: 91.0 },
        { name: "SW-03", value: 80.0, rankBadge: "▼1", previousValue: 81.0 },
        { name: "SN-04", value: 38.0, rankBadge: "▲1", previousValue: 37.0 },
        { name: "SN-01", value: 32.0, rankBadge: "▲4", previousValue: 28.0 },
        { name: "SN-07", value: 15.0, rankBadge: "NEW", previousValue: null }
      ]
    },
    poePowerChanges: [
      {
        switchName: "DGS-3630-28PC",
        previousWatts: 120,
        currentWatts: 310,
        changePercent: 158
      },
      {
        switchName: "DGS-1510-52MP",
        previousWatts: 429,
        currentWatts: 210,
        changePercent: -58
      },
      {
        switchName: "DGS-1250-28X",
        previousWatts: 65,
        currentWatts: 170,
        changePercent: 160
      },
      {
        switchName: "DGS-3020-28TC",
        previousWatts: 205,
        currentWatts: 226,
        changePercent: 10
      },
      {
        switchName: "DGS-1510-28P",
        previousWatts: 208,
        currentWatts: 110,
        changePercent: -47
      },
      {
        switchName: "DGS-1120-10MP",
        previousWatts: 60,
        currentWatts: 80,
        changePercent: 33
      },
      {
        switchName: "DGS-3130-30TS",
        previousWatts: 130,
        currentWatts: 90,
        changePercent: -30
      },
      {
        switchName: "DGS-1210-52MP",
        previousWatts: 305,
        currentWatts: 410,
        changePercent: 34
      },
      {
        switchName: "DGS-2000-10",
        previousWatts: 90,
        currentWatts: 122,
        changePercent: 35
      },
      {
        switchName: "DGS-1210-28P",
        previousWatts: 160,
        currentWatts: 115,
        changePercent: -28
      }
    ],
    availability: {}
  }
};

export const summaryReportOverviewSlice = createSlice({
  name: "summaryReportOverview",
  initialState,
});

export default summaryReportOverviewSlice.reducer;
